module.exports = __webpack_public_path__ + "static_pc/img/int02.0eab5cdf.png";